export class SolicitudDocumentosAtestViewModel {
    public Id: number;
    public IdEstado = 0;
    public IdTipoSolicitudInfCa = 0;
    public IdTipoSolicitudInfCaDescripcion = '';
    public IdEstadoDescripcion = '';

    public RefAtestFito: string;
    public CodigoTipoSolicitud: string;

    public TDocumentoSolicitudAtestFitoCollection: TDocumentoSolicitudAtestFitoViewModel[];
}

export class TDocumentoSolicitudAtestFitoViewModel {
    public Id: number;
    public IdSolicitudAtestFito: number;
    public IdPerfilAtestFito: number;

    public Texto = '';
    public Fecha: Date | null = null;

    public CodigoStorage = '';
    public OldCodigoStorageCollection?: string[] = [];
    public NombreArchivo = '';
    public Size: number | null = null;

    public IdEstado = 0;
    public IdEstadoDescripcion: string;

    public IdTipoSolicitudInfCa = 0;
    public IdTipoSolicitudInfCaDescripcion = '';

    public RefAtestFito: string;

    public IdPerfilAtestFitoDescription: string;
    public IdUsuario: number;

    public CodigoTipoSolicitud: string;
}
